import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "../../utils/axios";

const BASE = "/api/v1/erp/requisitions";

export const fetchRequisitions = createAsyncThunk("requisition/fetchAll", async (params?: string): Promise<any> => {
  const query = params ? `?${params}` : "";
  const response = await axios.get(`${BASE}${query}`);
  return response.data;
});

export const fetchRequisitionById = createAsyncThunk("requisition/fetchById", async (id: string): Promise<any> => {
  const response = await axios.get(`${BASE}/${id}`);
  return response.data;
});

export const addRequisition = createAsyncThunk("requisition/add", async (payload: any): Promise<any> => {
  const response = await axios.post(BASE, payload);
  return response.data;
});

export const updateRequisition = createAsyncThunk("requisition/update", async ({ id, payload }: any): Promise<any> => {
  const response = await axios.put(`${BASE}/${id}`, payload);
  return response.data;
});

export const submitRequisition = createAsyncThunk("requisition/submit", async (id: string): Promise<any> => {
  const response = await axios.post(`${BASE}/${id}/submit`);
  return response.data;
});

export const approveRequisition = createAsyncThunk("requisition/approve", async ({ id, items }: any): Promise<any> => {
  const response = await axios.post(`${BASE}/${id}/approve`, { items });
  return response.data;
});

export const rejectRequisition = createAsyncThunk("requisition/reject", async ({ id, reason }: any): Promise<any> => {
  const response = await axios.post(`${BASE}/${id}/reject`, { reason });
  return response.data;
});

export const createTransferFromRequisition = createAsyncThunk("requisition/createTransfer", async (id: string): Promise<any> => {
  const response = await axios.post(`${BASE}/${id}/create-transfer`);
  return response.data;
});

export const reopenRequisition = createAsyncThunk("requisition/reopen", async (id: string): Promise<any> => {
  const response = await axios.post(`${BASE}/${id}/reopen`);
  return response.data;
});

export const fetchRequisitionStockCheck = createAsyncThunk("requisition/stockCheck", async (id: string): Promise<any> => {
  const response = await axios.get(`${BASE}/${id}/stock-check`);
  return response.data;
});
